import React, { memo } from 'react'
import { ValidationErrorDisplay } from './ValidationErrorDisplay'

export interface FormFieldWrapperProps {
  label: React.ReactNode
  id: string
  children: React.ReactNode
  error?: string
  helperText?: string
  showHelper?: boolean
  fieldRef?: React.RefObject<HTMLDivElement>
  /** Constrains the whole field (label + input + error text) to the input's own width, so a long error message wraps instead of overflowing past a fixed-width input. */
  style?: React.CSSProperties
  /** Extra classes for the error message text only — see {@link ValidationErrorDisplayProps.messageClassName}. */
  errorMessageClassName?: string
}

export const FormFieldWrapper = memo<FormFieldWrapperProps>(({
  label,
  id,
  children,
  error,
  helperText,
  showHelper,
  fieldRef,
  style,
  errorMessageClassName,
}) => {
  // Simple approach: add an error class on the wrapper so nested inputs pick up styling
  const content = children
  return (
    <div
      ref={fieldRef}
      className={`ds-form w-full ${error ? 'ds-form--error ds-form__error-field' : ''}`}
      data-ds-theme="vessel"
      data-ds-variant="input"
      data-ds-version={error ? '2' : '1'}
      style={style}
    >
      {typeof label === 'string' ? <label htmlFor={id} className='p4 -medium'>{label}</label> : label}
      {content}
      {error && <ValidationErrorDisplay message={error} id={`${id}-error`} messageClassName={errorMessageClassName} />}
      {showHelper && helperText && !error && (
        <div className="helper-text text-xs text-gray-500 mt-1!" id={`${id}-helper`}>
          {helperText}
        </div>
      )}
    </div>
  )
})

FormFieldWrapper.displayName = 'FormFieldWrapper'

export default FormFieldWrapper
